/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpSubnetPerRegion {
  /**
  * Region.
  */
  'region': string;
  /**
  * Subnet name.
  */
  'subnetName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "subnetName",
      "baseName": "subnetName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpSubnetPerRegion.attributeTypeMap;
  }

  public constructor() {
  }
}

